'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'gauge-simple-low';
var width = 512;
var height = 512;
var aliases = ["tachometer-slow"];
var unicode = 'f62c';
var svgPathData = 'M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM200 352c0-14.4 5.4-27.5 14.4-37.5L153.8 169.2c-5.1-12.2 .7-26.3 12.9-31.4s26.3 .7 31.4 12.9l60.5 145.3c29.7 1.4 53.3 25.9 53.3 55.9 0 30.9-25.1 56-56 56s-56-25.1-56-56z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGaugeSimpleLow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;